import {FetchSuggestFunction} from '@logistics-frontend/blocks'
import {externalApiURL} from '@logistics-frontend/client-core/api/corp'
import {addQuery} from '@logistics-frontend/utils'

import {type SuggestBody, type SuggestObject, type SuggestResponse, SuggestAction} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'
import {toSuggest, toSuggestBody} from './fetch-address-suggest-utils'

type FetchAddressSuggest = FetchSuggestFunction<SuggestObject, SuggestResponse>

export const fetchAddressSuggest: FetchAddressSuggest = function fetchAddressSuggest(params) {
  const body = toSuggestBody(params)

  return fetch<SuggestBody, SuggestResponse, SuggestResponse>({
    url: addQuery(externalApiURL('phoenix/suggest'), {country: appConfig.countryCode}),
    method: 'post',
    headers: {
      'x-taxi': 'yandex.delivery',
    },
    body,
  }).then(response => ({
    type: body.action === SuggestAction.FINALIZE ? 'final' : 'in-progress',
    suggest: toSuggest(response),
    __origin: response,
  }))
}
